#import "../fragments/preference-center-audience-fragment.graphql"

mutation MakeAudiencePublic($input: AudienceUpdateInput!) {
    audienceUpdate(input: $input) {
        audience {
            ...PreferenceCenterAudience
        }
    }
}
